import { render, staticRenderFns } from "./MiniGameWrite.vue?vue&type=template&id=25a2dcad&"
import script from "./MiniGameWrite.vue?vue&type=script&lang=js&"
export * from "./MiniGameWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports